export const Card = ({ title, desc, icon: Icon, children, right, testid }) => (
  <section className="bg-white border border-slate-200 rounded-xl" data-testid={testid}>
    <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-3">
      {Icon && <span className="w-9 h-9 rounded-lg bg-slate-100 text-slate-700 grid place-items-center"><Icon size={17} /></span>}
      <div><h3 className="font-semibold text-slate-900">{title}</h3>{desc && <p className="text-xs text-slate-500">{desc}</p>}</div>
      <div className="ml-auto">{right}</div>
    </div>
    <div className="p-6">{children}</div>
  </section>
);
